import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPropertywareLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45875_66651)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 40,
				rx: 8,
				fill: "#1B74BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
				fill: "#1B74BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9511 8.16797C21.6163 8.18765 23.2867 8.15918 24.9589 8.17111C26.4115 8.18148 28.0915 8.10666 29.5121 8.44543C30.2975 8.6327 31.38 9.27459 31.9426 9.85137C32.9671 10.9015 33.4741 12.1794 33.4739 13.6412C33.4734 15.4179 32.9075 16.9239 31.6547 18.198C30.6269 19.2433 29.2014 19.742 27.7643 19.8442C27.2245 19.8825 26.6334 19.8685 26.0863 19.8684L23.5954 19.8668L23.3711 19.8682L22.2377 26.6518L16.876 26.6497C16.9488 26.1011 17.0621 25.4917 17.154 24.9406L17.6965 21.6974L19.9511 8.16797Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.6594 12.1958C25.8443 12.1958 27.8157 12.0004 28.1592 13.505C28.356 14.3676 28.0383 15.1248 27.2649 15.5556C26.263 16.0174 25.1238 15.9251 24.0332 15.9212L24.6594 12.1958Z",
				fill: "#1B74BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.5096 12.9888C17.8115 12.9707 18.0711 12.9764 18.3728 12.9824C18.2953 13.6217 18.15 14.2998 18.0581 14.9484C17.7008 14.9806 17.3879 15.0233 17.0545 15.1577C15.1437 15.8997 14.5425 18.3352 15.0622 20.1545C15.299 20.9834 15.6576 22.0036 15.9785 22.8207C15.4779 22.5357 14.9403 22.288 14.4347 22.009C13.7532 21.633 12.9808 21.3007 12.1885 21.3006C11.3697 21.299 10.5844 21.6257 10.0082 22.2076C7.52448 24.6975 9.52415 29.8424 12.8187 30.5108C13.4679 30.6424 14.3429 30.6015 15.0197 30.6018L17.9699 30.6017L29.2381 30.584C29.2752 30.8658 29.3147 31.1474 29.3568 31.4285L29.5248 32.5819L18.2986 32.5806L15.1589 32.5819C14.4986 32.5821 13.702 32.6199 13.0591 32.5153C9.11828 31.8734 6.34689 27.6085 6.98639 23.7381C7.21766 22.3386 7.94312 21.0081 9.11861 20.1861C10.262 19.382 11.5838 19.1936 12.941 19.4295C12.9321 19.3608 12.9244 19.292 12.918 19.223C12.6113 16.1576 14.2723 13.3001 17.5096 12.9888Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45875_66651",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 8,
			fill: "white"
		})
	}) })]
});
export default SvgPropertywareLogo;
